import { Badge, Clickable, Icon, Row } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const CartButton = ({}) => {
  const hasCart = useSelector((state) => state.user.cart)?.length,
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    navigate = useNavigate();

  return (
    <Clickable onClick={() => navigate('/cart')}>
      <Row noFlex centerAll bg={theme.GREY_10} hasRadius="40px" pad="10px">
        <Icon type="cart" dimensions={20} />
        {!!hasCart && <Badge absolute topDistance="8px" rightDistance="8px" />}
      </Row>
    </Clickable>
  );
};

export default CartButton;
